import React, { Component, useState } from 'react';

class SideBar extends Component {
    handleClick = (buttonId) => {
        this.props.onClick(buttonId);
    };
    render (){
        const { activeButton } = this.props;
        return (
        <div className="about-left-section">
            {/*<div className={`about-section ${activeButton === 'about1' ? 'active' : ''}`}
                onClick={() => this.handleClick('about1')}>
                <h1>About</h1>
            </div>*/}
            <div className="about-section">
                <h2>Intro</h2>
            </div>
            <div className={`about-section ${activeButton === 'about2' ? 'active' : ''}`}
                onClick={() => this.handleClick('about2')}>
                <h2>Introduction</h2>
            </div>
            <div className={`about-section ${activeButton === 'about3' ? 'active' : ''}`}
                onClick={() => this.handleClick('about3')}>
                <h2>Background</h2>
            </div>
            <div className={`about-section ${activeButton === 'about4' ? 'active' : ''}`}
                onClick={() => this.handleClick('about4')}>
                <h2>Education</h2>
            </div>
            <div className={`about-section ${activeButton === 'about5' ? 'active' : ''}`}
                onClick={() => this.handleClick('about5')}>
                <h2>Mission</h2>
            </div>
            <div className={`about-section ${activeButton === 'about6' ? 'active' : ''}`}
                onClick={() => this.handleClick('about6')}>
                <h2>Philosophy</h2>
            </div>
        </div>
    )}
}

export default SideBar;